export default __webpack_public_path__ + "static/media/7.bfce27a2.png";